export enum BuildRentStageType {
    Build = 0,
    Rent = 1,
}
